import FlexContainer from '@/components/atomic/atoms/layout/flex-container/styled';
import { BasicComponentProps } from '@/typings/generic';
import styled from '@emotion/styled';

const Link = styled(FlexContainer)<
	React.AnchorHTMLAttributes<HTMLAnchorElement> & BasicComponentProps
>(({ theme }) => ({
	color: theme.colors.primaryBrandColor,
	textDecoration: 'none',
	cursor: 'pointer',
})).withComponent('a');

export default Link;
